<ng-container *ngIf="eligibilityTree">
  <eas-editor-eligibility-operator *ngIf="eligibilityTree.rootOperator !== null"
    [operator]="eligibilityTree.rootOperator"
    [ruleList]="eligibilityTree.ruleList"
    [isLastSibling]="true"
  >
  </eas-editor-eligibility-operator>
</ng-container>

<ng-template #loading>
  <h1 i18n>Loading...</h1>
</ng-template>
